import React from 'react';
import chroma from 'chroma-js';
import { Link } from 'react-router-dom';

export default ({ badge, image='', title='', caption, position='left' }) => {

  const Luminance  = chroma(badge).get('lab.l');

  const Image = { backgroundImage: `url(${image})` };

  const badge_color = (Luminance <= 70) ? '#fff' : '#000';

  const badge_style = { backgroundColor: badge, color: badge_color };

  return (
    <Link to={`/products/${title}`} className={`Product-Category ${position}`}>

      <div className="Category-Image" style={Image}/>

      <div className="Category-Content">

        <div
          style={badge_style}
          className="Category-Name"
          dangerouslySetInnerHTML={{ __html: title.toUpperCase() }}
        />

        <div
          className="Category-Caption"
          dangerouslySetInnerHTML={{ __html: caption }}
        />

      </div>

    </Link>
  );

}
